import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import homeIcon from 'assets/icons/home.svg';

import { StyledBreacrumb, StyledBreacrumbList } from './styled';

const Breadcrumb = ({ location }) => {
  const paths = location.split('/');
  const isHome = location === '/';

  return (
    <>
      {!isHome && (
        <StyledBreacrumb>
          <StyledBreacrumbList>
            <li>
              <Link to="/dashboard" className="dashboard">
                <img src={homeIcon} alt="Dashboard" />
                Dashboard
              </Link>
            </li>

            {paths.map(path => {
              if (path === '') return false;

              return (
                <li key={path}>
                  <Link to={`/${path}`}>{path.charAt(0).toUpperCase() + path.slice(1)}</Link>
                </li>
              );
            })}
          </StyledBreacrumbList>
        </StyledBreacrumb>
      )}
    </>
  );
};

Breadcrumb.propTypes = {
  location: PropTypes.string,
};

export { Breadcrumb };
